const textFieldDefaultProps = {
  filled: true,
  rounded: true,
  'hide-details': true,
  dense: true,
  'background-color': '#ffffff',
};

export default textFieldDefaultProps;
